<!--
 * @Author: xiaoxi 2767862556@qq.com
 * @Date: 2022-06-13 17:03:59
 * @LastEditors: xiaoxi 2767862556@qq.com
 * @LastEditTime: 2022-06-21 19:12:46
 * @FilePath: \webpatient\src\views\physicalExaminationDetail\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <Common>
      <template slot="cd">
          <CdphysicalExaminationDetail />
      </template>
      <template slot="sz">
          <SzphysicalExaminationDetail />
      </template>
      <template slot="hf">
          <HfphysicalExaminationDetail />
      </template>
    </Common>
</template>

<script>
import CdphysicalExaminationDetail from "@/components/physicalExaminationDetail/cdphysicalExaminationDetail"
import SzphysicalExaminationDetail from "@/components/physicalExaminationDetail/szphysicalExaminationDetail"
import HfphysicalExaminationDetail from "@/components/physicalExaminationDetail/hfphysicalExaminationDetail"
export default{
  components:{
    CdphysicalExaminationDetail,
    SzphysicalExaminationDetail,
    HfphysicalExaminationDetail
  },
  
  data(){
    return {

    }
  },
  created(){

  }
}
</script>
<style lang="less" scoped>

</style>